export default "__VITE_ASSET__CZRjz6aL__"